import { Pipe, PipeTransform } from '@angular/core';
import { PaymentStatus } from '@techspert-io/engagements';

@Pipe({
  name: 'paymentStatus',
})
export class PaymentStatusPipe implements PipeTransform {
  private paymentStatusDisplayDictionary: Record<PaymentStatus, string> = {
    'not-paid': 'Not paid',
    'payment-sent': 'Payment sent',
    'payment-received': 'Payment received',
    'not-claimed': 'Not claimed',
  };

  transform(value: PaymentStatus) {
    return this.paymentStatusDisplayDictionary[value];
  }
}
